var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43575 9.21111C7.43575 8.82593 7.52142 8.50741 7.69274 8.25556C7.87151 8.0037 8.12849 7.72593 8.46369 7.42222C8.7095 7.2 8.88827 7.01481 9 6.86667C9.11918 6.71111 9.17877 6.53704 9.17877 6.34444C9.17877 6.07037 9.06704 5.85556 8.84358 5.7C8.62756 5.53704 8.33706 5.45556 7.97207 5.45556C7.62197 5.45556 7.30912 5.52963 7.03352 5.67778C6.76536 5.81852 6.53818 6.01852 6.35196 6.27778L5 5.48889C5.31285 5.01481 5.73371 4.64815 6.26257 4.38889C6.79888 4.12963 7.43203 4 8.16201 4C9.01862 4 9.70391 4.18148 10.2179 4.54444C10.7393 4.90741 11 5.41111 11 6.05556C11 6.35926 10.9479 6.62593 10.8436 6.85556C10.7467 7.08519 10.6238 7.28148 10.4749 7.44444C10.3333 7.6 10.1471 7.78148 9.9162 7.98889C9.6406 8.23333 9.43948 8.44074 9.31285 8.61111C9.18622 8.77407 9.12291 8.97407 9.12291 9.21111H7.43575ZM8.28492 12C7.97952 12 7.72253 11.9037 7.51397 11.7111C7.31285 11.5111 7.21229 11.2704 7.21229 10.9889C7.21229 10.7074 7.31285 10.4741 7.51397 10.2889C7.71508 10.0963 7.97207 10 8.28492 10C8.59776 10 8.85475 10.0963 9.05587 10.2889C9.25698 10.4741 9.35754 10.7074 9.35754 10.9889C9.35754 11.2704 9.25326 11.5111 9.04469 11.7111C8.84358 11.9037 8.59032 12 8.28492 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e5aaaff98c5b5061835ac21c872f1f4d.svg";
export { ForwardRef as ReactComponent };